var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.6797C4 7.81369 7.13401 4.67969 11 4.67969C14.866 4.67969 18 7.81369 18 11.6797C18 13.5655 17.2543 15.2771 16.0417 16.5358C16.0073 16.5622 15.9743 16.5911 15.9428 16.6226C15.9113 16.654 15.8824 16.6871 15.856 16.7215C14.5973 17.934 12.8857 18.6797 11 18.6797C7.13401 18.6797 4 15.5457 4 11.6797ZM16.6176 18.7116C15.078 19.9432 13.125 20.6797 11 20.6797C6.02944 20.6797 2 16.6503 2 11.6797C2 6.70912 6.02944 2.67969 11 2.67969C15.9706 2.67969 20 6.70912 20 11.6797C20 13.8047 19.2635 15.7577 18.0319 17.2974L21.707 20.9726C22.0975 21.3631 22.0975 21.9963 21.707 22.3868C21.3165 22.7773 20.6833 22.7773 20.2928 22.3868L16.6176 18.7116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.430b95152c42dca901723dc03405ceb0.svg";
export { ForwardRef as ReactComponent };